<template>
  <div class="sair">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12 text-center middle">
          <h1 class="text-uppercase">Deslogando do sistema</h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sair',
  created() {
    this.$store.dispatch('startLoader');
    localStorage.removeItem('voltarLogin');
    this.$store.dispatch('exitLogin').then(() => {
      setTimeout(() => {
        this.$store.dispatch('endLoader');
        this.$router.push({ name: 'home' });
      }, 1000);
    });
  },
};
</script>
